import { SecurityBwicHistoryState } from "../../types/state/entities/SecurityBwicHistoryState";
import { getType } from "typesafe-actions";
import { securityBwicHistoryActions, TSecurityBwicHistoryActions } from "../../actions/entities/security-bwic-history.actions";
import { RequestState } from "../../constants/request-state";

export const securityBwicHistoryIntialState: SecurityBwicHistoryState = {
    history: {}
}

export function securityBwicHistoryReducer(
    state: SecurityBwicHistoryState = securityBwicHistoryIntialState,
    action: TSecurityBwicHistoryActions
): SecurityBwicHistoryState {
    switch (action.type) {
        case getType(securityBwicHistoryActions.request):
            return {
                history: {
                    ...state.history,
                    [action.payload.securityId]: {
                        requestState: RequestState.request,
                        bwics: {
                            count: 0,
                            securities: []
                        }
                    }
                }
            };
        case getType(securityBwicHistoryActions.requestResult):
            return {
                history: {
                    ...state.history,
                    [action.payload.securityId]: {
                        requestState: RequestState.success,
                        bwics: action.payload.bwicHistory
                    }
                }
            };
        case getType(securityBwicHistoryActions.requestFailure):
            return {
                history: {
                    ...state.history,
                    [action.payload.securityId]: {
                        requestState: RequestState.failure,
                        bwics: {
                            count: 0,
                            securities: []
                        }
                    }
                }
            };
        case getType(securityBwicHistoryActions.reset):
            return {...securityBwicHistoryIntialState}
        default:
            return state;
    }
}
